import { ClienteEditOut } from '../../../../model/clientes';
import Common, { Stores } from '../../../common';
import { IComboItem, IPaginatedResponse, IResponse } from '../../../model';
import ServiceBase from '../../../servicebase';
import { ICliente, IClienteEmailTemplate, IClienteVoucherTemplate, IMedioPago } from '../model';
import { IClienteAdjunto } from '../model/relations/IClienteAdjunto';

export default class ClienteService extends ServiceBase {
  //ya migrados
  combo = (data: { activos?: boolean, includeTodos?: boolean, includeNinguno?: boolean, includeId?: number }) : Promise<IResponse<IComboItem[]>> => 
    this.GetFetch<IResponse<IComboItem[]>>('clientes/cliente/combo', data);

  getEdit = (data:{ id?: number, codigo?: string }) : Promise<IResponse<ClienteEditOut>> => 
    this.GetFetch<IResponse<ClienteEditOut>>('clientes/cliente/edit', data);

  find = (data:{ pageIndex?: number, pageSize?: number, sort?: string, id?: number, nombre?:string, cuit?: string, codigo?:string, padreNombre?: string; asesor?:string, idsistemaexterno?: string, activo?: boolean }) : Promise<IPaginatedResponse<ICliente>> => 
    this.GetFetch<IPaginatedResponse<ICliente>>('clientes/cliente/find', data);

  upsert = (data:ICliente) : Promise<IResponse<ICliente>> => 
    this.PostFetch<IResponse<ICliente>>('clientes/cliente', data);

  delete = (data:{ id: number, undelete?: boolean}) : Promise<IResponse<void>> => 
    this.DeleteFetch<IResponse<void>>('clientes/cliente', data);





  all = (useCache?: boolean) : Promise<IResponse<ICliente[]>> => 
    Common.indexedDB.StoreControl.apiget(Stores.Clientes, () => this.GetFetch<IResponse<ICliente[]>>('entity/cliente/all', {}));
/*
  vendedores_actives = (data: { idcliente?: number, includes?: number[] }) : Promise<IResponse<{ id:number, nombre: string }[]>> =>
    this.GetFetch<IResponse<{ id:number, nombre: string }[]>>('entity/cliente/vendedores/actives', data);
*/
  emailtemplate_all = (data:{ idcliente?: number }) : Promise<IResponse<IClienteEmailTemplate[]>> => 
    this.GetFetch<IResponse<IClienteEmailTemplate[]>>('entity/cliente/emailtemplates/all', data);
    
  vouchertemplate_all = (data:{ idcliente?: number }) : Promise<IResponse<IClienteVoucherTemplate[]>> => 
    this.GetFetch<IResponse<IClienteVoucherTemplate[]>>('entity/cliente/vouchertemplates/all', data);

  proveedores_all = (data:{ idcliente?: number }) : Promise<IResponse<{ id: number; nombre?: string; comision?: number }[]>> => 
      this.GetFetch<IResponse<{ id: number; nombre?: string; comision?: number }[]>>('entity/cliente/proveedores/all', data);

  mediopagos_actives = (data:{ idcliente?: number }) : Promise<IResponse<IMedioPago[]>> => 
    this.GetFetch<IResponse<IMedioPago[]>>('entity/cliente/mediopagos/actives', data);
    
  adjuntos_all = (data:{ idcliente?: number }) : Promise<IResponse<IClienteAdjunto[]>> => 
    this.GetFetch<IResponse<IClienteAdjunto[]>>('entity/cliente/adjuntos/all', data);
    
  adjuntos_insert = (data:IClienteAdjunto) : Promise<IResponse<unknown>> => 
    this.PostFetch<IResponse<unknown>>('entity/cliente/adjuntos', data);
    
  adjuntos_delete = (data:{ id?: number }) : Promise<IResponse<unknown>> => 
    this.DeleteFetch<IResponse<unknown>>('entity/cliente/adjuntos', data);
    
  remitentes_all = (data:{ idcliente?: number, tipoEmailTemplate?: string }) : Promise<IResponse<any[]>> => 
    this.GetFetch<IResponse<any[]>>('entity/cliente/remitentes/all', data);

  remitentes_actives = (data:{ idcliente?: number, tipoEmailTemplate?: string }) : Promise<IResponse<any[]>> => 
    this.GetFetch<IResponse<any[]>>('entity/cliente/remitentes/actives', data);
  
  emailtemplates_all = (data:{ idcliente?: number, tipoEmailTemplate?: string }) : Promise<IResponse<any[]>> => 
    this.GetFetch<IResponse<any[]>>('entity/cliente/emailtemplates/all', data);

  emailtemplates_actives = (data:{ idcliente?: number, tipoEmailTemplate?: string }) : Promise<IResponse<any[]>> => 
    this.GetFetch<IResponse<any[]>>('entity/cliente/emailtemplates/actives', data);
  
}

